import { render, staticRenderFns } from "./ContractMenu.vue?vue&type=template&id=85ac5f4c&scoped=true"
import script from "./ContractMenu.vue?vue&type=script&lang=js"
export * from "./ContractMenu.vue?vue&type=script&lang=js"
import style0 from "./ContractMenu.vue?vue&type=style&index=0&id=85ac5f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ac5f4c",
  null
  
)

export default component.exports